import { MethodOfReception } from 'bus/methodOfReception/types';
import { RequestPriceResponse } from 'bus/request/types';

export const calcPumpPriceMinimal = (form: MethodOfReception, data: RequestPriceResponse) => {
  if (form.pumpQuantity <= data.minQuantity) {
    return form.pumpPriceMinimalFilledManually ? form.pumpPriceMinimal : data.pumpPriceMinimal;
  } else {
    return form.pumpPriceMinimalFilledManually ? form.pumpPriceMinimal : 0;
  }
};

export const calcPumpPrice = (form: MethodOfReception, data: RequestPriceResponse) => {
  if (form.pumpQuantity <= data.minQuantity) {
    return form.pumpPriceFilledManually ? form.pumpPrice : 0;
  } else {
    return form.pumpPriceFilledManually ? form.pumpPrice : data.price;
  }
};
